import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";
const target =
  process.env.NODE_ENV === "development"
    ? `ws://${window.location.hostname}:3010`
    : process.env.SOCKET_HOST || `wss://sampick.io`;
const url = `${target}/sampick`;
export { VueSocketIO, SocketIO, url };
